import { ListItem } from '@fs/zion-ui'
import Ellipsis from '@fs/zion-ui/dist/cjs/ellipsis'
import React from 'react'
import { shape, string, number, elementType } from 'prop-types'
// Component for leaderboard list items

export const ListItemContent = ({ person, AvatarIcon, PointsIcon }) => (
  <ListItem
    startElement={<ListItem.Icon Icon={AvatarIcon} person={person} size="sm" />}
    emphasized
    primaryText={<Ellipsis lineClamp={2}>{person?.userProfileName}</Ellipsis>}
    endElement={<ListItem.Icon Icon={PointsIcon} points={person?.points} />}
  />
)

ListItemContent.propTypes = {
  person: shape({
    userProfileName: string,
    points: number,
  }),
  AvatarIcon: elementType,
  PointsIcon: elementType,
}
